<div class="insights-container">
  <div *ngIf="compareToFleet; else elseBlock">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <!-- <div class="col-md-6 ps-0 pe-0">
        <app-charged-energy-ef-chart [selectedVehicles]="selectedVehicles" [vehiclesChargingInsightsDataPoint]="vehiclesChargingInsightsDataPoint"></app-charged-energy-ef-chart>
      </div> -->
      <div class="col-md-4 ps-0 pe-0">
        <app-soc-delta-per-charging-ef-chart [selectedVehicles]="selectedVehicles" *ngIf="fleetId.length > 0"
          [fleetId]="fleetId"></app-soc-delta-per-charging-ef-chart>
      </div>
      <div class="col-md-4 ps-0 pe-0">
        <app-initial-state-of-charge-ef-chart [selectedVehicles]="selectedVehicles" [dataLoadingSoc]="dataLoadingSoc"
          [errorMessageSoc]="errorMessageSoc" [stateOfChargeDatapoints]="stateOfChargeDatapoints"
          *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-initial-state-of-charge-ef-chart>
      </div>
      <div class="col-md-4 ps-0 pe-0">
        <app-end-state-of-charge-ef-chart [selectedVehicles]="selectedVehicles" [dataLoadingSoc]="dataLoadingSoc"
          [errorMessageSoc]="errorMessageSoc" [stateOfChargeDatapoints]="stateOfChargeDatapoints"
          *ngIf="fleetId.length > 0" [fleetId]="fleetId"></app-end-state-of-charge-ef-chart>
      </div>
    </div>

    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-soc-events-low-ef-chart [selectedVehicles]="selectedVehicles" [dataLoadingSocEvents]="dataLoadingSocEvents"
          [errorMessageSocEvents]="errorMessageSocEvents" [stateOfChargeEventsDatapoints]="stateOfChargeEventsDatapoints"
          [vehiclesChargingInsightsDataPoint]="vehiclesChargingInsightsDataPoint" *ngIf="fleetId.length > 0"
          [fleetId]="fleetId"></app-soc-events-low-ef-chart>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <app-soc-events-high-ef-chart [selectedVehicles]="selectedVehicles" [dataLoadingSocEvents]="dataLoadingSocEvents"
          [errorMessageSocEvents]="errorMessageSocEvents" [stateOfChargeEventsDatapoints]="stateOfChargeEventsDatapoints"
          [vehiclesChargingInsightsDataPoint]="vehiclesChargingInsightsDataPoint" *ngIf="fleetId.length > 0"
          [fleetId]="fleetId"></app-soc-events-high-ef-chart>
      </div>
    </div>

  </div>

  <ng-template #elseBlock>
    <rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
    <div class="row ms-0 me-0">
      <div class="col-12">
          <table class="m-table" *rbTable="loader; fixedHeaderWidth: false; columns: 6" [rbSort]="{id: '', direction: ''}" (rbSortChange)="currentVehicleData = sortData($event, currentVehicleData)">
            <thead>
              <tr>
                <th rb-sort-header="vehicleName" [disableSortClear]="true">Vehicle Name</th>
                <th>
                  <span>
                    Analyzed Time Period
                  </span>
                </th>
                <th rb-sort-header="chargedEnergy" [disableSortClear]="true">
                  <span
                    rbTooltip="Charged Energy (Accumulated) refers to the total amount of electrical energy that has been supplied to an EV battery over time through charging sessions. This metric helps track battery usage patterns, efficiency, and potential degradation over time." [noFix]="false">
                    Charged Energy (Accumulated)
                  </span>
                </th>
                <th rb-sort-header="equivalentFullCycles" [disableSortClear]="true">
                  <span
                    rbTooltip="The usage of batteries is often measured in cycles, which include one full charge and discharge procedure.
                    This can indicate the stress of the battery by its usage. One equivalent full cycle (EFC) requires  that the equivalent energy amount has been charged and discharged as a full charge and discharge, but does not require to be reach lower or upper state of charge limits.
                    Thereby it is more useful in real-life applications, in which 0% state of charge is typically avoided. The value helps to put the usage of batteries in perspective of there different sizes and helps to compare them in particular if the same battery cells are used in different numbers.
                    It is important to note, that the sensitivity of aging to EFC can be different for different batteries and in particular if different chemistries are used." [noFix]="false">
                    Equivalent Full Cycles
                  </span>
                </th>
                <th rb-sort-header="lowSocEvents" [disableSortClear]="true">
                  <span
                    rbTooltip="The count of times the battery's charge dropped to a low  state of health (≤20%), which can affect battery health." [noFix]="false">
                    Number of Low State of Charge Events
                  </span>
                </th>
                <th rb-sort-header="highSocEvents" [disableSortClear]="true">
                  <span
                    rbTooltip="The count of times the battery was charged to a high  state of health (≥80%), which can impact battery aging." [noFix]="false">
                    Number of High State of Charge Events
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let vehicleData of currentVehicleData; let i = index">
                <tr>
                  <td>
                    {{ vehicleData.vehicleName !== null && vehicleData.vehicleName !== undefined && vehicleData.vehicleName !== '' ? vehicleData.vehicleName : 'N/A' }}
                  </td>
                  <td>
                    <span [innerHTML]="formatDateWithNbsp(vehicleData.timeWindowsStart)"></span>
                    <br>
                    <span [innerHTML]="formatDateWithNbsp(vehicleData.timestamp)"></span>
                  </td>
                  <td>
                    {{ vehicleData.chargedEnergy !== null && vehicleData.chargedEnergy !== undefined 
                        ? (vehicleData.chargedEnergy | whToKwh | removeDecimalPoints:1) + ' kWh' 
                        : 'N/A' }}
                  </td>
                  <td>
                    {{ vehicleData.fullChargeCycles !== null && vehicleData.fullChargeCycles !== undefined 
                        ? (vehicleData.fullChargeCycles | removeDecimalPoints:0) 
                        : 'N/A' }}
                  </td>
                  <td>
                    {{ vehicleData.lowSocEvents !== null && vehicleData.lowSocEvents !== undefined 
                        ? (vehicleData.lowSocEvents | removeDecimalPoints:0) 
                        : 'N/A' }}
                  </td>
                  <td>
                    {{ vehicleData.highSocEvents !== null && vehicleData.highSocEvents !== undefined 
                        ? (vehicleData.highSocEvents | removeDecimalPoints:0) 
                        : 'N/A' }}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
      </div>
    </div>

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-4 ps-0 pe-0">
        <app-charged-energy-over-time-chart [selectedVehicles]="selectedVehicles"></app-charged-energy-over-time-chart>
      </div>
      <div class="col-md-4 ps-0 pe-0">
        <app-soc-delta-per-charging-procedure-chart
          [selectedVehicles]="selectedVehicles"></app-soc-delta-per-charging-procedure-chart>
      </div>
      <div class="col-md-4 ps-0 pe-0">
        <app-regenerative-charging-chart [selectedVehicles]="selectedVehicles"></app-regenerative-charging-chart>
      </div>
    </div>

    <hr class="ms-2 me-2 mt-1 mb-1 ps-0 pe-0">

    <div class="row ms-2 me-2 mt-1 mb-1 ps-0 pe-0">
      <div class="col-md-6 ps-0 pe-0">
        <app-soc-start-chart [selectedVehicles]="selectedVehicles"></app-soc-start-chart>
      </div>
      <div class="col-md-6 ps-0 pe-0">
        <app-soc-end-chart [selectedVehicles]="selectedVehicles"></app-soc-end-chart>
      </div>
    </div>

  </ng-template>
</div>